import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getSidebarStatus, getSize, setSidebarStatus, setSize } from '@/utils/cookies'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop,
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
  size: string,
  navbarSearch: string,
  navbarDate: Array<string>
  showNavbarSeatch: boolean // 是否展示navbar搜索框；
  showNavbarDateFilter: boolean // 是否展示navbar时间筛选框
  showNavbarPlaceValue: string // navbar地区名字
}

// dynamic: true 动态创建动态模块, 所以new Vuex.Store({})里面不用注册
// store, 当前模块注册到store上。也可以写在getModule上, 即getModule(App, store)
@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  // state => 要定义为public，不然外面调用不到
  public sidebar = {
    opened: getSidebarStatus() !== 'closed',
    withoutAnimation: false
  }

  public device = DeviceType.Desktop
  public size = getSize() || 'medium'
  public navbarSearch = ''
  public navbarDate: string[] = [];
  public showNavbarSeatch = false
  public showNavbarDateFilter = false
  public showNavbarPlaceValue = ''

  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      setSidebarStatus('opened')
    } else {
      setSidebarStatus('closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device
  }

  @Mutation
  private SET_SIZE(size: string) {
    this.size = size
    setSize(this.size)
  }

  @Mutation
  private SET_NAVBAR_SEARCH(search: string) {
    this.navbarSearch = search
  }

  @Mutation
  private SET_SHOW_NAVBAR_SEARCH(value: boolean) {
    this.showNavbarSeatch = value
  }

  @Mutation
  private SET_NAVBAR_DATE(value: string[]) {
    this.navbarDate = value
  }

  @Mutation
  private SET_SHOW_NAVBAR_DATE(value: boolean) {
    this.showNavbarDateFilter = value
  }

  @Mutation
  private SET_SHOW_NAVBAR_PLACE(placename: string) {
    this.showNavbarPlaceValue = placename
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public SetSize(size: string) {
    this.SET_SIZE(size)
  }

  @Action
  public SetNavbarSearch(search: string) {
    this.SET_NAVBAR_SEARCH(search)
  }

  @Action
  public SetShowNavbarSearch(value: boolean) {
    this.SET_SHOW_NAVBAR_SEARCH(value)
  }

  @Action
  public SetNavbarDate(value: string[]) {
    this.SET_NAVBAR_DATE(value)
  }

  @Action
  public SetShowNavbarDate(value: boolean) {
    this.SET_SHOW_NAVBAR_DATE(value)
  }

  @Action
  public SetShowNavbarPlace(placename: string) {
    this.SET_SHOW_NAVBAR_PLACE(placename)
  }
}

// getModule:创建类型安全的访问
export const AppModule = getModule(App)
